// ============================================================================
// FINGERPRINT — Generates a stable device fingerprint for anonymous identity.
//
// Combines canvas rendering, screen info, timezone, and browser features
// into a hash. Same device always produces the same fingerprint, so each
// teacher keeps their wizard persona across sessions.
//
// Not used for tracking — only for mapping device → consistent anon name.
// ============================================================================

let _cachedFingerprint = null;

function simpleHash(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash |= 0; // Convert to 32-bit int
  }
  return Math.abs(hash).toString(36);
}

function getCanvasFingerprint() {
  try {
    const canvas = document.createElement("canvas");
    canvas.width = 200;
    canvas.height = 50;
    const ctx = canvas.getContext("2d");
    
    // Draw text with specific styling — renders slightly different per GPU/OS
    ctx.textBaseline = "top";
    ctx.font = "14px Arial";
    ctx.fillStyle = "#7c3aed";
    ctx.fillText("Wyzcon Intel 🧙", 2, 2);
    
    ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
    ctx.fillRect(75, 1, 100, 20);
    
    ctx.fillStyle = "#f59e0b";
    ctx.font = "18px Georgia";
    ctx.fillText("anonymous", 4, 25);
    
    return canvas.toDataURL().slice(-50);
  } catch {
    return "no-canvas";
  }
}

function getScreenFingerprint() {
  return [
    window.screen.width,
    window.screen.height,
    window.screen.colorDepth,
    window.devicePixelRatio || 1,
  ].join("x");
}

function getBrowserFeatures() {
  return [
    navigator.language || "",
    navigator.hardwareConcurrency || 0,
    navigator.maxTouchPoints || 0,
    Intl.DateTimeFormat().resolvedOptions().timeZone || "",
    new Date().getTimezoneOffset(),
    navigator.platform || "",
  ].join("|");
}

export function generateFingerprint() {
  if (_cachedFingerprint) return _cachedFingerprint;

  const components = [
    getCanvasFingerprint(),
    getScreenFingerprint(),
    getBrowserFeatures(),
  ].join(":::");

  _cachedFingerprint = simpleHash(components);
  return _cachedFingerprint;
}

/**
 * Get the fingerprint as a header object to include in API calls.
 */
export function getFingerprintHeader() {
  return { "X-Fingerprint": generateFingerprint() };
}
